import { RequestData } from '@ant-design/pro-table';
import { request } from '@/utils/request';

const url = '/earn/subscriptions';
export interface SubscriptionList {
  id: string;
  refId: string;
  accountNumber: string;
  userId: string;
  walletId: string;
  userName: string;
  principle: number;
  interest: number;
  offerId: string;
  offerName: string;
  type: string;
  asset: string;
  rewardAsset: string;
  maturityDate: Date;
  time: string;
  startTime?: string;
  amount: number;
  autoRenew: boolean;
  hedged: boolean | string;
  requireClientConfirmation: boolean;
  bankDetails?: string;
  manual?: boolean;
  annualBase?: number;
  redemptions: Array<{
    id: string;
    refId: string;
    amount: number;
    asset: string;
    time: string;
  }>;
  tenor: [number, string];
  status?: string;
  estimateReward: number;
  remarkAttachments?: [{ key: string; url: string }];
  clientApr: number;
  relationshipManager: string;
  providerId?: string;
  settlementWalletId?: string;
  sourceSubscriptionId?: string | null;
  redemptionFeeSnapshotId?: string;
  costAprPercent: number;
  aprMarkdownPercent: number;
  clientAprPercent: number;
  hedgeAprPercent?: number;
  hedgeInterest?: number;
  redemptionFeeAmount?: string;
  redemptionFeeCurrency?: string;
  redemptionTenor: [number, string];
  autoRenewable?: boolean;
  tagIds?: Array<string>;
  tags?: Array<{ id: string; name: string; tagColor: string }>;
}

export interface OfferProvider {
  id: string;
  name: string;
}

export type ManualSubscriptionEligibilityReason = 'EARN_FEATURE_DISABLED' | 'EARN_ACCOUNT_NOT_ENABLED';

export type ManualSubscriptionEligibility =
  | {
      eligible: true;
      reason: null;
    }
  | {
      eligible: false;
      reason: ManualSubscriptionEligibilityReason;
    };

export async function querySubscriptionList(params: any): Promise<RequestData<SubscriptionList>> {
  params.action = 'SUBSCRIPTION';
  return await request<RequestData<SubscriptionList>>(url, {
    params
  });
}

export async function queryOfferProvider(): Promise<{ data: OfferProvider[] }> {
  const providers = await request<OfferProvider[]>(`/earn/providers`);
  return {
    data: providers
  };
}

export async function queryManualSubscriptionEligibility(userId: string): Promise<ManualSubscriptionEligibility> {
  return request<ManualSubscriptionEligibility>(`${url}/manual/eligibility`, {
    method: 'GET',
    params: { userId }
  });
}

/**
 * Get pending earn subscriptions count
 * Includes both REQUESTED (awaiting operator approval) and
 * PENDING_CLIENT_CONFIRMATION (awaiting client response, operator monitors)
 */
export async function queryEarnSubscriptionsPendingCount(): Promise<number> {
  const [requested, pendingConfirmation] = await Promise.all([
    request<RequestData<SubscriptionList>>(url, {
      params: { action: 'SUBSCRIPTION', current: 1, pageSize: 1, status: 'requested' }
    }),
    request<RequestData<SubscriptionList>>(url, {
      params: { action: 'SUBSCRIPTION', current: 1, pageSize: 1, status: 'pending_client_confirmation' }
    })
  ]);
  return (requested.total ?? 0) + (pendingConfirmation.total ?? 0);
}
